import { useEffect, useState } from "react";
import "./Pagination.style.scss";

export function Pagination(props) {
    const { totalPages, onPageChange, maxVisible = 15 } = props;
    const [currentPage, setCurrentPage] = useState(props.currentPage);

    useEffect(() => {
        setCurrentPage(props.currentPage);
    }, [props.currentPage]);

    const handlePageNumberClick = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            onPageChange(pageNumber);
            setCurrentPage(pageNumber);
        }
    };

    const pageListItems = () => {
        const comps = [];

        // --- START SHIFT LOGIC ---
        let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
        let endPage = startPage + maxVisible - 1;

        if (endPage > totalPages) {
            endPage = totalPages;
            startPage = Math.max(1, endPage - maxVisible + 1);
        }
        // --- END SHIFT LOGIC ---

        for (let i = startPage; i <= endPage; i++) {
            comps.push(
                <li key={i}>
                    <span
                        className={"paginationItem" + (currentPage === i ? " activePageItem" : "")}
                        onClick={() => handlePageNumberClick(i)}
                    >
                        {i}
                    </span>
                </li>
            );
        }
        return comps;
    };

    return (
        <nav>
            <ul className="pagination">
                {/* First Button */}
                <li onClick={() => handlePageNumberClick(1)}>
                    <span
                        className={"paginationItem" + (currentPage === 1 ? " disabled" : "")}
                        aria-label="Previous"
                    >
                        <i class="fa fa-angle-double-left" style={{ fontSize: 20 }} />
                    </span>
                </li>

                {/* Previous Button */}
                <li onClick={() => handlePageNumberClick(currentPage - 1)}>
                    <span
                        className={"paginationItem" + (currentPage === 1 ? " disabled" : "")}
                        aria-label="Previous"
                    >
                        <i class="fa fa-angle-left" style={{ fontSize: 20 }} />
                    </span>
                </li>

                {pageListItems()}

                {/* Next Button */}
                <li onClick={() => handlePageNumberClick(currentPage + 1)}>
                    <span
                        className={"paginationItem" + (currentPage === totalPages ? " disabled" : "")}
                        aria-label="Next"
                    >
                        <i class="fa fa-angle-right" style={{ fontSize: 20 }} />
                    </span>
                </li>
                {/* Last Button */}
                <li onClick={() => handlePageNumberClick(totalPages)}>
                    <span
                        className={"paginationItem" + (currentPage === totalPages ? " disabled" : "")}
                        aria-label="Next"
                    >
                        <i class="fa fa-angle-double-right" style={{ fontSize: 20 }} />
                    </span>
                </li>
            </ul>
        </nav>
    );
}

/*
import { useEffect, useState } from "react"
import "./Pagination.style.scss"

// 
//  currentPage should be 0 based indexs
//  

export function Pagination(props) {
    
    const {totalPages, onPageChange} = props
    const [currentPage, setCurrentPage] = useState(props.currentPage)

    useEffect(()=>{
        setCurrentPage(props.currentPage);
    }, [props.currentPage])

    const handlePageNumberClick = (pageNumber) => {
        onPageChange(pageNumber)
        setCurrentPage(pageNumber)
    }

    const pageListItems = () => {
        const comps = []

        if(totalPages > 15) { 
            for(let i = 1; i <= 15; i++) { 
                comps.push(
                    <li key={i}>
                       <span 
                            className={"paginationItem" + ((currentPage === i) ? " activePageItem" : "")}
                            onClick={() => handlePageNumberClick(i)}
                        >
                            {i}
                        </span> 
                    </li>
                )
            }  
        } else { 
            for(let i = 1; i <= totalPages; i++) { 
                comps.push(
                    <li key={i}>
                       <span 
                            className={"paginationItem" + ((currentPage === i) ? " activePageItem" : "")}
                            onClick={() => handlePageNumberClick(i)}
                        >
                            {i}
                        </span> 
                    </li>
                )
            }
        }
        
        return comps
    }
    return (
        <nav>
            <ul className="pagination">
                <li>
                    <span 
                        className="paginationItem" 
                        aria-label="Previous"
                    >
                        <span aria-hidden="true">&laquo;</span>
                    </span>
                </li>
                {pageListItems()}
                <li>
                    <span 
                        className="paginationItem" 
                        aria-label="Next"
                    >
                        <span aria-hidden="true">&raquo;</span>
                    </span>
                </li>
            </ul>
            </nav>
    )
}
*/
